export default __webpack_public_path__ + "static/media/card-blog10.217f99db.jpg";